import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export type TeamMemberRole = 'OWNER' | 'ADMIN' | 'EDITOR' | 'VIEWER';

export interface TeamMember {
  id: string;
  creatorProfileId: string;
  userId: string;
  role: TeamMemberRole;
  permissions: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: string;
    username: string;
    email: string;
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
}

export interface InviteTeamMemberPayload {
  email: string;
  role: TeamMemberRole;
  permissions?: string[];
}

export interface UpdateTeamMemberPayload {
  role?: TeamMemberRole;
  permissions?: string[];
  isActive?: boolean;
}

export const teamMembersService = {
  async getTeamMembers(creatorId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/team-members/creator/${creatorId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { teamMembers: TeamMember[] };
  },

  async inviteTeamMember(payload: InviteTeamMemberPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/team-members/invite`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string; teamMember: TeamMember };
  },

  async updateTeamMember(id: string, payload: UpdateTeamMemberPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/team-members/${id}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string; teamMember: TeamMember };
  },

  async removeTeamMember(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/team-members/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },
};


